import * as Popover from '@radix-ui/react-popover'
import { Link01Icon } from '@hugeicons/core-solid-rounded'
import { Trans, useLingui } from '@lingui/react/macro'

import ToolbarButton from './ToolbarButton'
import Input from '@/components/ui/Input'
import { useEffect, useState } from 'react'
import Button from '@/components/ui/Button'
import { popoverContainer } from '@/utils/popovers'

interface Props {
  link?: string
  onAddLink: (link: string) => void
}

export default function LinkToolbarButton(props: Props) {
  const { link, onAddLink } = props

  const { t } = useLingui()
  const [value, setValue] = useState('')

  useEffect(() => setValue(link ?? ''), [link])

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <ToolbarButton
          label={t({
            comment:
              'Aria label, to let users know that they can wrap a selected text with a link in our text editor.',
            message: `Wrap or Edit Link`
          })}
          Icon={Link01Icon}
          active={!!link}
        />
      </Popover.Trigger>
      <Popover.Portal container={popoverContainer}>
        <Popover.Content className="flex flex-col gap-4 rounded bg-white p-5 shadow-md z-popover">
          <Input
            value={value}
            onChange={event => setValue(event.target.value)}
            type="url"
          />
          <div className="flex flex-row justify-end">
            <Button onClick={() => onAddLink(value)}>
              <Trans>Save</Trans>
            </Button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
